import _ from "lodash";
const {generateFetchFieldListAction} = require('../../../../apps/KpModule/actions/api')

export const entity = {
    name: 'Project',
    facets: ['conversations'],
    fields: [
        {path: 'code', unique: true},
        {path: 'name'},
        'Company',
        {type: 'Contact', link: 'MTM', nullable: true},
        {path: 'team', type: 'User', link: 'MTM'},
        'description',
        {path: 'status', type: 'ProjectStatus'},
        {path: 'priority', type: 'Influence'},
        {path: 'state', type: 'Status'},
        {type: 'GroupAndCompany'},
        {path: 'type', type: 'Subject'},
        {
            path: "sequence", unique: true, ps: {
                object: [{
                    type: "nextSequence",
                    sequenceId: "k.projectSeq",
                    formatResult: result => {
                        const prefixLength = 4 - result.toString().length
                        const prefix = _.range(prefixLength).reduce(result => result + '0', '')
                        return `${prefix}${result}`
                    }
                }]
            }
        },
    ],
    filters: [
        {
            name: 'onlyOngoingProspectiveProject',
            isDefault: false,
            query: function() {
                return { status: {$in: ['ongoing', 'prospective']} }
            }
        },
        {
            name: 'onlyOwner',
            isDefault: false,
            query: function(context) {
                const userId = _.get(context, 'user.id')
                if (userId)
                    return { team: {$elemMatch: {$eq: new global.ObjectID(userId)} } }
                else
                    return {_id: null}
            }
        },
        {
            name: 'onlyUserInTeam',
            isDefault: false,
            query: function(context) {
                const userId = _.get(context, 'user.id')
                if (userId)
                    return { team: {$elemMatch: {$eq: new global.ObjectID(userId) } } }
                else
                    return {_id: null}
            }
        }
    ],
    ps: {
        context: [{
            $$u: function (context, callback) {
                if (this.options.accessType === "S" && context.restAction && context.restAction.crudType === "C") {
                    context.internalFieldPath = [
                        ...new Set([
                            ...context.internalFieldPath,
                            "sequence"
                        ])
                    ]
                }
                callback(null, context)
            }
        }]
    },
    beforeSave: function(newObject, oldObject, context, callback) {
        const action = context.restAction && context.restAction.crudType

        if (action === 'C') {
            const prefix = newObject.groupAndCompany.joinedEntity === 'Unit' ? 'Groupe' : 'Société'
            newObject.code = `${prefix} ${newObject.groupAndCompany.code} - ${newObject.type.code} - ${newObject.sequence}`
        }

        callback(null, newObject, oldObject)
    }
}

export const module_ = {
    object: 'Project',
    category: {
        path: 'dossier',
        icon: 'briefcase'
    },
    defaultSortBy: 'code',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            {path: 'groupAndCompany', initiallyNotVisible: true},
            'type',
            'code',
            'name',
            {path: 'contacts', tKey: 'Interlocuteurs'},
            { path: 'contacts', tKey: 'interlocutor' },
            {path: 'team', initiallyNotVisible: true},
            'status',
            'priority',
            {path: 'state', initiallyNotVisible: true},
        ],
        form: {
            fields: [
                {
                    path: 'groupAndCompany',
                    display: 'fullName',
                    placeholder : 'sélectionner le groupe ou la société du projet',
                    subscriptions: {
                        onChange: (newValue, oldValue, { store }) => {
                            const contactQuery = {groupAndCompany: {id: newValue?.id}}
                            store.dispatch(
                                generateFetchFieldListAction(
                                    'm-K-project.Project_contacts',
                                    store.getState,
                                    {data: contactQuery}
                                )
                            )
                        }
                    }
                },
                {path: 'type', display: 'fullName', placeholder : 'sélectionner le type du projet'},
                {path: 'code', placeholder: 'code du projet', required: false, disabled: true},
                {path: 'name', placeholder: 'renseigner le nom du projet'},
                { path: 'description', tKey: 'synthèse', type: 'richTextEditor', placeholder: 'saisir une description synthétique du projet' },
                {
                    path: 'contacts',
                    tKey: 'Interlocuteurs',
                    placeholder : 'sélectionner les interlocuteurs du projet',
                    filters: ['byGroupAndCompany']
                },
                {
                    path: 'team',
                    placeholder : 'sélectionner les membres de l’équipe du projet',
                    filters: ['isInGroupModel'],
                    /*
                    $default: (context) => {
                        return context?.user?.id ?
                            context?.user?.k ? [] : [{id: context?.user?.id}]
                            : []
                    }
                     */
                },
                {path: 'status', placeholder : 'sélectionner le statut du projet'},
                {path: 'priority', placeholder : 'sélectionner le niveau de priorité du projet'},
                {path: 'conversations', tKey: 'suivi'},
                {path: 'state', type: 'toggle', default: {id: 'actif'}}
            ]
        }
    },
    filters: [
        {
            path: 'company',
            tKey: 'groupAndCompany',
            object: 'GroupAndCompany',
            display: 'fullName',
            client: true,
            clearable: true,
            default: null,
            query: function(context) {
                const companyId = _.get(context.data, 'company.id')
                if (companyId)
                    return { groupAndCompany: new global.ObjectID(companyId) }
                return {}
            }
        },
        {
            path: 'subject',
            tKey: 'type',
            object: 'Subject',
            display: 'fullName',
            client: true,
            clearable: true,
            placeholder: 'selectSubject',
            default: {id: null},
            query: function(context) {
                const subjectId = _.get(context.data, 'subject.id')
                if (subjectId)
                    return { type: new global.ObjectID(subjectId) }
                return {}
            }
        },
        {
            path: 'projectStatus',
            tKey: 'status',
            object: 'ProjectStatus',
            display: 'name',
            client: true,
            clearable: true,
            placeholder: 'selectSubjectStatus',
            default: {id: 'ongoing'},
            query: function(context) {
                const projectStatusId = _.get(context.data, 'projectStatus.id')
                if (projectStatusId)
                    return { status: projectStatusId }
                return {}
            }
        },
        'onlyOwner'
    ]
}
